"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _NJNW7W5Mcjs = require('../__chunks/NJNW7W5M.cjs');
require('../__chunks/DD7MF4PQ.cjs');
require('../__chunks/XRATBFDX.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');



exports.CompositeGroupLabel = _NJNW7W5Mcjs.CompositeGroupLabel; exports.useCompositeGroupLabel = _NJNW7W5Mcjs.useCompositeGroupLabel;
